import { Fragment } from 'react';
import '../App.css';
import ReactLoading from "react-loading";
import './styles/loading.css';

function ShowLoading() {
    const loadingText = [
        "Sorting through our prime glossary", 
        "Navigating the corridors of our language archive",
        "Exploring the depths of our word vault",
        "Traversing the landscape of our database",
        "Delving into our digital archives for premium answers",
        "Probing our data bank for the best matches",
        "Sifting through our database for the finest findings",
        "Ṣíṣàwárí àkọlé iṣẹ́ díjítàlì wa fún ìdáhùn ààyé",
        "Sísẹ̀wúrà nínú ìkànsí ọrọ̀ wa",
        "Sísẹ́díẹ̀ lọ́wọ́ ìkànsí sẹ̀bà wa fún ìdáhùn tó dára jù"
    ]

    return (
      <div className='loading-overlay'>
        <div className='loading-content'>
              <Fragment>
                  <ReactLoading type="bars" color="#0000FF" height={100} width={50} />
                  <p>{loadingText[Math.floor(Math.random()*loadingText.length)]}...</p>
              </Fragment>
        </div>
      </div>
    );
  }
    
  export default ShowLoading;